<template>
  <label class="radio" :class="{ 'radio--readonly': readonly, 'radio--error': error }">
    <span class="radio__text">
      <span v-if="icon" v-html="icon" class="radio__icon"></span>
      <span class="radio__label">
        <slot name="label" />
        <span class="radio__additional">
          <slot name="label-additional" />
        </span>
      </span>
    </span>
    <input
        type="radio"
        :value="value"
        :checked="value === checked"
        :name="name"
        @change="onRadioChange($event.target.value)"
    />
    <span class="radio__radiomark"></span>
  </label>
</template>

<script>
export default {
  name: 'AppRadio',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: [Boolean, String, Number],
    checked: [Boolean, String, Number],
    id: String,
    name: String,
    readonly: Boolean,
    error: Boolean,
    icon: String,
  },
  methods: {
    onRadioChange(value) {
      if (value === 'true') value = true
      if (value === 'false') value = false
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="sass">
.radio
  display: flex
  align-items: center
  position: relative
  padding-left: 25px
  cursor: pointer

  input
    +visually-hidden

    &:checked ~ .radio__radiomark
      border-color: $color-theme
      border-width: 5px

.radio--readonly
  pointer-events: none
  cursor: default

  //input
  //  & ~ .radio__radiomark
  //    border-color: $color-readonly
  //
  //    &:after
  //      background-color: $color-readonly
  //
  //  &:checked ~ .radio__radiomark
  //    border-color: $color-readonly

.radio--error
  input
    & ~ .radio__radiomark
      border-color: $color-error

    &:checked ~ .radio__radiomark
      border-color: $color-error

.radio--minw
  .radio__additional
    min-width: 180px

.radio__radiomark
  display: flex
  align-items: center
  justify-content: center
  position: absolute
  top: 2px
  left: 0
  width: 15px
  height: 15px
  background-color: #fff
  border: 1px solid $color-border
  box-sizing: border-box
  border-radius: 50%

.radio__text
  display: flex
  align-items: center
  gap: 0 6px
  font-size: 13px
  font-weight: 400
  line-height: 20px
  color: $color-text-base

.radio__icon
  line-height: 0

.radio__label
  position: relative

.radio__additional
  position: absolute
  left: 0
  top: 80%
  color: #868686
  font-size: 12px
</style>
